// source: template-project@7007a338a apps/backoffice/src/pages/onboarding-v2/Transcript.tsx (UserMessage)
import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface UserMessageProps {
  children: ReactNode;
  /** Rise into place (TP's entrance). Off for lines that were already there when the chat opened. Default on. */
  animate?: boolean;
}

/** TP's entrance for a turn: a short fade and a 4px rise, never under reduced motion. */
export const TURN_ENTRANCE_CLASS = 'animate-in fade-in slide-in-from-bottom-1 duration-300 motion-reduce:animate-none';

/** The person's turn: a right-aligned bubble on the 5% ink wash, no border. */
export function UserMessage({ children, animate = true }: UserMessageProps) {
  return (
    <div
      data-testid="chat-message"
      data-role="user"
      className={cn('group/message flex justify-end', animate && TURN_ENTRANCE_CLASS)}
    >
      <div
        data-message-text
        className="min-w-0 max-w-[80%] break-words rounded-lg bg-ds-ink-a05 px-4 py-2.5 text-body-sm text-foreground"
      >
        {children}
      </div>
    </div>
  );
}
